import { prop, includes, pipe, filter, path, memoizeWith, isNil, isEmpty } from 'ramda'
import { utils } from '@digital-commerce/shared-utils'
import { getTermInYears, splitMessages } from '../../molecules/CartItem/utils'
import { formatCurrency } from '../../../utils/currency'
import { getCacheKey } from '../../../utils/cart'

const { getTopLevelItems, getMonthlyTotalPrice } = utils.cart

export const getGifts = memoizeWith(
  getCacheKey('Gift'),
  pipe(getTopLevelItems, filter(pipe(prop('tags'), includes('gift'))))
)

export const getConfiguratorDescription = pipe(
  path(['content', 'configuratorDescription']),
  splitMessages
)

export const buildRecurringTermDiscount = (service, translate, lang) => {
  const { discount } = getMonthlyTotalPrice(service) ?? {}
  if (discount <= 0 || !discount) return null

  const terms = getTermInYears(service)

  return {
    id: service.id,
    name: translate('promotionWithTerm', { replacements: { numberOfYear: terms } }),
    price: `-${formatCurrency(discount, lang)}`,
    prefixIcon: 'DEALS'
  }
}

export const isAOptikTVGift = pipe(prop('tags'), includes('optik'))

export const getLegalFootnoteKey = (service) => {
  return isAOptikTVGift(service)
    ? 'OptikTVGiftCancellationFeeLegalSlug'
    : 'internetGiftCancellationFeeLegalSlug'
}

export const shouldRender = (cart) => {
  const offers = getGifts(cart)
  return !isNil(offers) && !isEmpty(offers)
}
